// extracted by mini-css-extract-plugin
export default {"inputEditable":"EditableSpan_inputEditable__fz7Fb","spanEditable":"EditableSpan_spanEditable__OMJNv","spanEditableHilight":"EditableSpan_spanEditableHilight__jGyqr"};